import { AfterViewInit, Component, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatToolbar } from '@angular/material/toolbar';
import { MenuComponent } from './shared/menu/menu.component';
import { AuthService } from '@lib-ui/auth/auth.service';
import { UpperCasePipe } from '@angular/common';
import { CommonDropdownComponent } from '@lib-ui/common-dropdawn/common-dropdown.component';
import { CompanySelectorService } from '@lib-services/company-selector.service';
import { FormControl } from '@angular/forms';
import { filter } from 'rxjs';
import { SessionStorageService } from '@lib-services/session-storage.service';
import { TimeZoneComponent } from './components/time-zone/time-zone.component';
import { TimeZoneService } from '@lib-services/time-zone.service';
import { GroupsService } from '@lib-services/groups.service';

@Component({
    standalone: true,
    imports: [RouterModule, MatToolbar, MenuComponent, UpperCasePipe, CommonDropdownComponent, TimeZoneComponent],
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, AfterViewInit {
    pageName = signal<string>('');
    companyControl = new FormControl;

    constructor(
        protected authService: AuthService,
        protected companySelectorService: CompanySelectorService,
        protected groupsService: GroupsService,
        protected sessionStorageService: SessionStorageService,
        protected timeZoneService: TimeZoneService,
    ) {}

    ngOnInit(): void {
        const companyId = Number(this.sessionStorageService.getItem('companyId'));

        this.timeZoneService.timeZoneInit();

        if(companyId) {
            this.authService.companyId.set(companyId);
            this.companyControl.setValue(companyId);
        }

        this.companyControl.valueChanges.pipe(filter(id => id)).subscribe(id => {
            this.authService.companyId.set(id);
            this.groupsService.currentGroupId.set(null);
            this.sessionStorageService.setItem('companyId',id);
        });
    }

    ngAfterViewInit(): void {
        this.authService.authCheck();
    }

    logout(): void {
        this.authService.logout();
    }

}
